export default __webpack_public_path__ + "static/escalator_w.b26787350ffd57c7bc145d538a51faa4.png";